import React from 'react';
import styled from '@emotion/styled';
import { useLocale, useTexts } from '@devsisters/gatsby-plugin-i18n';

import { scaledCss } from '~/src/css';
import { asset } from '~/src/assets';
import getHelloBraveCookiesReceiveUrl from '~/src/misc/getHelloBraveCookiesReceiveUrl';

interface ReceiveButtonProps {
  className?: string;
  mid: string;
  event?: string;
}
const ReceiveButton: React.FC<ReceiveButtonProps> = ({
  className,
  mid,
  event,
}) => {
  const locale = useLocale();
  const t = useTexts();
  return (
    <ReceiveButtonAnchor
      id="receive-button"
      className={className}
      href={getHelloBraveCookiesReceiveUrl(mid, event)}
      target="_blank">
      <ReceiveButtonImg
        src={asset(`bravecookies/receive-button/${locale}.png`)}
        alt={t`$get.button`}
      />
    </ReceiveButtonAnchor>
  );
};

export default ReceiveButton;

const ReceiveButtonAnchor = styled('a')(
  scaledCss({
    margin: '0 auto',
    marginTop: [40, '40px'],
    marginBottom: [50, '50px'],
    display: 'block',
  })
);
const ReceiveButtonImg = styled('img')(
  scaledCss({
    width: [436, '436px'],
  })
);
